import React from 'react';
import { Box } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import Content from './components/Content';
import Title from './components/Title';

const Card = ({ children, ...props }) => (
  <Box
    bg="white"
    {...props} // eslint-disable-line react/jsx-props-no-spreading
  >
    {children}
  </Box>
);

Card.propTypes = {
  children: PropTypes.node.isRequired,
  ...Box.propTypes,
};

Card.Title = Title;
Card.Content = Content;

export default Card;
